import styled, { css } from 'styled-components'

const CustomMapWrapper = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
            height: 64.5vw;
            min-height: 64.5vw;

            @media ${device.tabletM} {
                height: 42vw;
                min-height: 42vw;
            }
        `;
    }}
`;

const CustomMap = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
            height: 64.5vw;
            min-height: 64.5vw;
            position: relative;
            padding: 0px;
            margin: 0 10px;
            margin-top: 115px;
            &:hover {
                // height: 125.6vw;
                height: calc(100vh - 297px);
            }
            @media ${device.tabletM} {
                height: 43vh;
                min-height: 43vh;
                grid-column: 2/3;
                grid-row: 2/3;
                margin: 0 60px 0 100px;
                margin-top: 150px;

                &:hover {
                    height: calc(100vh - 297px);
                    // height: 49.5vw;
                }
            }
        `;
    }}
`;

const SelectAreaContainer = styled.div`
    ${({ theme }) => {
        const { fonts, colors } = theme;
        return css`
        box-sizing: border-box;
        // font-size: ${fonts.size.small};
        position: relative;
        width: 237px;
        height: 35px;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        background-size: 20px;
        cursor: pointer;
        margin-top: 15px;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: ${colors.blue_3};
        `;
    }}
`;

const SelectAreaAbsoluteContainer = styled(SelectAreaContainer)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        position: absolute;
        top: 12px;
        left: 12px;
        z-index: 1;
        width: 200px;
        height: 40px;
        margin-top: 0px;
        border-radius: 10px;
        border: none;
        &:focus {
            outline: none;
        }
        &:active {
            outline: none;
        }
        & div {
            border: none;
        }
        & div:focus {
            outline: none;
        }
        & div:active {
            outline: none;
        }
        @media ${device.tabletM} {
            top: 20px;
            left: 20px;
            font-size: 18px;
            line-height: 20px;
            width: 300px;

            & div {
                align-items: center;
            }
        }
        `;
    }}
`;

const Map = styled.div`
    ${({ theme }) => {
        return css`
            // position: absolute;
            top: 0;
            bottom: 0;
            width: calc(100vw - 20px);
            height: 100%;
        `;
    }}
`;

const LayerControl = styled.div`
    ${({ theme }) => {
        return css`
            position: absolute;
            top: 98px;
            right: 20px;
            z-index: 1;
            background: #FFFFFF;
            border: 1px solid #A7C9CF;
            box-sizing: border-box;
            border-radius: 5px;
            width: 31px;
            height: 31px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 0 0 2px rgb(0 0 0 / 10%);
        `;
    }}
`;

const LayerPanel = styled.div`
    ${({ theme }) => {
        return css`
            position: absolute;
            top: 132px;
            right: 20px;
            z-index: 1;
            background: #FFFFFF;
            border: 1px solid #A7C9CF;
            box-sizing: border-box;
            border-radius: 5px;
            width: 152px;
            height: 113px;
            display: flex;
            flex-direction: column;
            padding: 12px;
            justify-content: space-between;
            align-items: start;
        `;
    }}
`;

const LayerPanelItem = styled.div`
    ${({ theme }) => {
        return css`
            display: flex;
            color: #869396;
            cursor: pointer;
        `;
    }}
`;

const Checkbox = styled.div`
    ${(props) => {
        return css`
        width: 16px;
        height: 16px;
        border: 1px solid ${props.color ? props.color : '#869396'};
        border-radius: 2px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: ${props.color ? props.color : '#869396'};
        `;
    }}
`;

const LayerItem = styled.div`
    ${(props) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        color: ${props.color ? props.color : '#869396'};
        `;
    }}
`;

const styledComponents = { CustomMapWrapper, CustomMap, Map, SelectAreaContainer, SelectAreaAbsoluteContainer, LayerControl, LayerPanel, LayerPanelItem, Checkbox, LayerItem };

export default styledComponents;